// Source: https://confluence.zurich.com/display/KUNDPL/Validierung+von+Zeichenketten
export const policyIdReg = /^\d{4}(-[A-Za-z0-9]+){1,2}$/
export const quoteIdReg = /^\d{1,12}$/
export const partnerProxyIdReg = /^\d+$/
export const partnerAdressIdReg = /^\d+$/
